export const formatDMY = (date) => {
    const tmp = date.split('-');
    const date_dmy = tmp[2] + '/' + tmp[1] + '/' + tmp[0];
    return date_dmy;
}

export const formatYMD = (date) => {
    const tmp = date.split('/');
    const date_ymd = tmp[2] + '-' + tmp[1] + '-' + tmp[0];
    return date_ymd;
}

export const dateSub = (date, n) => {
    let tmpDate = new Date(Date.parse(formatYMD(date)));
    tmpDate = new Date(
        tmpDate.setDate(
            tmpDate.getDate() - n)
    ).toLocaleDateString("en-GB", { timeZone: 'Africa/Lagos' });
    return tmpDate;
}